export default __webpack_public_path__ + "static/media/graph-up.680d0fdb.svg";